module.exports = __webpack_public_path__ + "static/media/volar-internacional.9d479d0f.png";